import Vue from 'vue'
import VueMq from 'vue-mq'
import viewportUnitsBuggyfill from 'viewport-units-buggyfill'
import deviceInfo from '@/lib/deviceInfo'
import DexieClient from '@/lib/DexieClient'
import initGlobalComponent from './initGlobalComponent'
import initVeeValidate from './initVeeValidate'
import initVueFilter from './initVueFilter'

export default function() {
  initGlobalComponent()
  initVeeValidate()
  initVueFilter()

  Vue.use(VueMq, {
    breakpoints: {
      sm: 767,
      md: 768
    }
  })

  viewportUnitsBuggyfill.init({ force: true })

  Vue.prototype.$deviceInfo = deviceInfo()
  Vue.prototype.$dexieClient = new DexieClient()
  Vue.config.productionTip = false
}
